<script>
  const tagValidator = (_) => ['div', 'section'].includes(_);

  export default {
    name: 'UiContainer',
    props: {
      tag: {
        type: String,
        default: 'div',
        validator: tagValidator,
      },
      fluid: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      genRoot() {
        const { $style } = this;

        return this.$createElement(this.tag, {
          class: {
            [$style.root]: true,
            [$style.isFluid]: this.fluid,
          },
        }, this.$slots.default);
      },
    },
    render() {
      return this.genRoot();
    },
  };
</script>

<style lang="scss" module>
  .root {
    padding-left: 15px;
    padding-right: 15px;
    margin-right: auto;
    margin-left: auto;
    box-sizing: content-box;

    &.isFluid {
      max-width: map-get($gridMaxWidth, 'xl');
    }

    &:not(.isFluid) {
      max-width: calc(100% - 15px);

      @include mediaMin('sm') {
        max-width: map-get($gridMaxWidth, 'sm');
      }

      @include mediaMin('md') {
        max-width: map-get($gridMaxWidth, 'md');
      }

      @include mediaMin('lg') {
        max-width: map-get($gridMaxWidth, 'lg');
      }

      @include mediaMin('xl') {
        max-width: map-get($gridMaxWidth, 'xl');
      }
    }
  }
</style>
